import React, { Component } from 'react'
import { Button, Popup } from 'semantic-ui-react';

import CreateNewWorkspaceModal from './../../../account/dashboard/drive/Modal/CreateNewWorkspaceModal'
import "./Toolbar.css";


class ToolbarAccountHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createNewWorkspaceModalFlag: false,
            type: null
        }
        this.openCreateNewWorkspaceModal = this.openCreateNewWorkspaceModal.bind(this)
    }

    openCreateNewWorkspaceModal(open, type) {
        this.setState({
            createNewWorkspaceModalFlag: open,
            type: type
        })
    }


    render() {
        /**
         * User Access control 
         * Account user can not create workspace only owner can
         */
        let isCreateWorkspaceDisabled = false;
        let account = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0];
        if (account.role === "user" && this.props.selectedAccount.subscriptionType !== "Workgroup") {
            isCreateWorkspaceDisabled = true; // for now user is aloowed to create wokspace
        } else if (account.role === "customerAdmin" && account.isActive === false) {
            isCreateWorkspaceDisabled = true; // if account is disabled, account owner can not create workspace
        }

        return (
            <div className="toolBar header_buttons">
                <Button.Group size='mini' >

                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={<Button icon='plus'
                            className="clr-blue"
                            onClick={() => this.openCreateNewWorkspaceModal(true, "create", null)}
                            disabled={isCreateWorkspaceDisabled}
                        />
                        }
                        content='Create New Workspace'
                    />
                </Button.Group>
                <CreateNewWorkspaceModal
                    open={this.state.createNewWorkspaceModalFlag}
                    type={this.state.type}
                    data={this.state.data}
                    accountId={this.props.selectedAccount._id}
                    user={this.props.user}
                    orgCreationError={this.props.orgCreationError}
                    //closeCreateNewWorkspaceModal={this.closeCreateNewWorkspaceModal}
                    openCreateNewWorkspaceModal={this.openCreateNewWorkspaceModal}
                    accountSubscriptionDetail={this.props.accountSubscriptionDetail}
                    history={this.props.history}
                    selectedAccount={this.props.selectedAccount}
                    tableFilterQuery={this.props.tableFilterQuery}
                />
            </div>
        )
    }
}

export default ToolbarAccountHome

